import { z } from 'zod';

// Table columns
export const getColumns = (entityTypes = []) => [
  {
    id: 'entityName',
    label: 'Entity name',
    width: '200px',
    minWidth: '180px',
  },
  {
    id: 'permanentAccountNumber',
    label: 'Entity pan',
    width: '140px',
    minWidth: '120px',
  },
  {
    id: 'taxDeductionAccountNumber',
    label: 'Entity tan',
    width: '140px',
    minWidth: '120px',
  },
  {
    id: 'entityType',
    label: 'Entity type',
    width: '250px',
    type: 'dropdown',
    options: entityTypes.map(type => ({ id: type, value: type, label: type })),
  },
  {
    id: 'nameOfResponsiblePerson',
    label: "Responsible person's name",
    width: '250px',
    align: 'left',
  },
  {
    id: 'designation',
    label: "Responsible person's designation",
    width: '280px',
    align: 'left',
  },
  {
    id: 'active',
    label: "Active",
    width: '100px',
    align: 'left',
    render: value => (value ? 'Yes' : 'No'),
    type:'dropdown',
    options:[
  { id: 'yes', value: 'Yes', label: 'Yes' },
  { id: 'no', value: 'No', label: 'No' },
]
  },
  {
    id: 'createdBy',
    label: 'Created by',
    width: '160px',
    minWidth: '120px',
  },
  {
    id: 'createdDate',
    label: 'Created date',
    width: '180px',
    minWidth: '160px',
  },
  {
    id: 'lastModifiedBy',
    label: 'Updated by',
    width: '160px',
    minWidth: '120px',
  },
  {
    id: 'lastModifiedDate',
    label: 'Updated date',
    width: '180px',
    minWidth: '160px',
  },
]

//  yyyy-mm-dd validation
const ddMMyyyyListZod = z
  .string()
  .regex(
    /^((0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}(\s*,\s*(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4})*)?$/,
    'Invalid Input. Example: 29/08/2025, 01/09/2025'
  )

// Search fields constant (add Load ID and all columns)
export const getSearchFields = (entityTypes = []) => [
  ...getColumns(entityTypes).map(col => {
    if (col.id === 'createdDate' || col.id === 'lastModifiedDate') {
      return {
        id: col.id,
        label: col.label,
        type: 'text',
        placeholder: `Example: 25/08/2025 (dd/mm/yyyy)`,
        zod: ddMMyyyyListZod,
      };
    }
    return {
      ...col,
      id: col.id,
      label: col.label,
      type: col.type || 'text',
      placeholder: `Enter ${col.label}`,
    };
  }),
];
